import { useTranslation } from 'react-i18next';
import { comparisonData } from '@/mocks/seoContent';

export default function ComparisonTable() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('comparison.title')}
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Zobacz, jak Kakobuy Spreadsheet wypada na tle tradycyjnego przeszukiwania produktów w chińskich marketplaceach.
          </p>
        </div>

        <div className="bg-white rounded-lg border border-background-200 overflow-hidden">
          <div className="grid grid-cols-3 bg-background-100 border-b border-background-200">
            <div className="p-4 md:p-5 text-sm md:text-base font-semibold text-foreground-900">Funkcja</div>
            <div className="p-4 md:p-5 text-sm md:text-base font-semibold text-primary-600 text-center">{t('comparison.colSpreadsheet')}</div>
            <div className="p-4 md:p-5 text-sm md:text-base font-semibold text-foreground-500 text-center">{t('comparison.colStandard')}</div>
          </div>

          {comparisonData.map((row, idx) => (
            <div
              key={idx}
              className={`grid grid-cols-3 border-b border-background-100 last:border-b-0 ${
                idx % 2 === 0 ? 'bg-white' : 'bg-background-50/50'
              }`}
            >
              <div className="p-4 md:p-5 text-sm text-foreground-700">{row.feature}</div>
              <div className="p-4 md:p-5 text-center">
                {typeof row.spreadsheet === 'boolean' ? (
                  row.spreadsheet ? (
                    <span className="inline-flex items-center gap-1 text-accent-600 font-medium text-sm">
                      <i className="ri-check-line"></i> Tak
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1 text-foreground-400 text-sm">
                      <i className="ri-close-line"></i> Nie
                    </span>
                  )
                ) : (
                  <span className="text-sm font-medium text-primary-600">{row.spreadsheet}</span>
                )}
              </div>
              <div className="p-4 md:p-5 text-center">
                {typeof row.standard === 'boolean' ? (
                  row.standard ? (
                    <span className="inline-flex items-center gap-1 text-accent-600 font-medium text-sm">
                      <i className="ri-check-line"></i> Tak
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1 text-foreground-400 text-sm">
                      <i className="ri-close-line"></i> Nie
                    </span>
                  )
                ) : (
                  <span className="text-sm text-foreground-500">{row.standard}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}